import { Icon } from '@material-ui/core';
import { Form } from 'react-bootstrap';
import DataTable from '../../../ShearCompo/DataTable/DataTable';

const AssignAuthority = () => {
    const tableHeading = ['SL', 'Page Name', 'Read Only Access', 'Read and White Access', 'Admin Access'];
    const tableData = [
        {
            id: '1',
            pageName: 'Dashboard',
            readOnlyAccess: true,
            readAndWhiteAccess: true,
            adminAccess: true,
        },
        {
            id: '2',
            pageName: 'Admin- Manage Users',
            readOnlyAccess: true,
            readAndWhiteAccess: true,
            adminAccess: true,
        },
        {
            id: '3',
            pageName: 'Admin- Manage Groups',
            readOnlyAccess: true,
            readAndWhiteAccess: true,
            adminAccess: true,
        },
        {
            id: '4',
            pageName: 'Admin- Manage Roles',
            readOnlyAccess: true,
            readAndWhiteAccess: true,
            adminAccess: true,
        }
    ]

    return (
        <div id="admin_assignAuthority">
            <div className="assignAuthorityTitle">
                <h3>Assign Authority</h3>
                <div className="row mb-3">
                    <div className="col-lg-4">
                        <select className="form-select" aria-label="Default select example">
                            <option defaultValue="">Admin</option>
                            <option value="1">manager</option>
                            <option value="2">CEO</option>
                            <option value="3">What</option>
                        </select>
                    </div>
                    <div className="col-lg-2">
                        <button className=" btn btn-success px-5">Update</button>
                    </div>
                </div>
            </div>

            <DataTable
                iconHeading={true}
                tableInputFrom={
                    <Form className="col-lg-5 p-0 tableSearch topInputFrom" id="topInputFrom1">
                        <div className="form-bd shadow-sm rounded">
                            <div className="input-group">
                                <div className="input-group-prepend">
                                    <button id="button-addon3" type="submit" className="btn btn-link text-muted d-flex align-items-center">
                                        <Icon className="mt-1">search</Icon>
                                    </button>
                                </div>
                                <input type="search" placeholder="Search assign admin" className=" topSearchInput form-control rounded " />
                            </div>
                        </div>
                    </Form>
                }
                tableHeading={tableHeading} tableBodyData={
                    tableData && tableData.map((tableData, index) =>
                        <tr key={index} className="text-center">
                            <th scope="row">#{tableData.id}</th>
                            <td>{tableData.pageName}</td>
                            <td>
                                <Icon className="bg-success text-success">check_box_outline_blank</Icon>&nbsp;
                                {tableData.readOnlyAccess ? 'Yes' : 'No'}
                            </td>
                            <td>
                                <Icon className="bg-success text-success">check_box_outline_blank</Icon>&nbsp;{tableData.readAndWhiteAccess ? 'Yes' : 'No'}
                            </td>
                            <td>
                                <Icon className="bg-success text-success">check_box_outline_blank</Icon>&nbsp;{tableData.adminAccess ? 'Yes' : 'No'}
                            </td>
                        </tr>
                    )
                } />
        </div>
    );
};

export default AssignAuthority;